export const REQUEST_ORDER_PRODUCT = "hardwareOrders.REQUEST_ORDER_PRODUCT";
export const RECEIVE_ORDER_PRODUCT = "hardwareOrders.RECEIVE_ORDER_PRODUCT";
